import SwiperComponent from '@/js/core/SwiperComponent'
import Swiper from 'swiper'

export default class LatestNews extends SwiperComponent {
  static root = '[data-latest-news]'

  state = {
    ...this.state,
    breakpointWatch: true,
  }

  addSwiper () {
    const { swiperContainer } = this.$els
    this.swiper = new Swiper(swiperContainer, {
      spaceBetween: 10,
    })
  }
}